import type { FaireProductEntity } from "../../entity_types/product";

export const p_y877sxbdah: FaireProductEntity = {
  token: "p_y877sxbdah",
  type: "product",
  name: "Tennis Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/6bed24a82b178b77b695005cdf20be8f25fa4dbc73d609e638658bcf916612d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ca977317b79bce07317baf890811f927f89bf4dd578f6376a4377f1cb7df813.jpeg",
    "https://cdn.faire.com/fastly/14a63f90cfb7b5c6e85443bc6ffc78a33d74d0e3ac195a21f9b84d2ab5ebab51.jpeg",
    "https://cdn.faire.com/fastly/5da76f19be654a2b6d0db3e18d3926511dde8155a203c74dbb28f9bb1111f78d.jpeg"
  ],
  priceDollars: 7,
  description: "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:45.511Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
